export function ToPlainText(text: string): string {
  if (typeof text !== 'string') {
    return text;
  }

  if (!text) {
    return '';
  }

  const regex = /<.*?>/g;
  return text
    .replace(/\&amp;/g, '')
    .replace(/\&nbsp;/g, '')
    .replace(regex, '');
}
